import { TablePagination } from '@components/pagination/tablePagination';
import { ColumnFilterPopover } from '@components/popover/columnsFilterPopover';
import { useAgreementsTable } from '@components/tables/agreements';
import { useToggleTableColumns } from '@hooks/useToggleTableColumns';
import { BaseLayout } from '@layouts/base';
import { MetaData, Agreement } from '@root/globalTypes';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FiltersProvider } from '@ctx/filters';
import { Filters } from '@components/filters';
import { config } from './filtersConfig';
import { MobileFilters } from '@components/filters/mobileFilters';

type AgreementsProps = {
  agreements: Agreement[];
  meta?: MetaData;
  onRowSelect: (id: string) => void;
};

export const Agreements = ({ meta, agreements, onRowSelect }: AgreementsProps) => {
  const { t } = useTranslation('app');
  const predefinedCols = useMemo(
    () => [
      'id',
      'agreement_id',
      'max_use',
      'variablity',
      'expiry',
      'status',
      'created_at',
      'updated_at',
    ],
    [],
  );
  const { visibleColumns, setColumns } = useToggleTableColumns({ predefinedCols });
  const { columns, Table: AgreementsTable } = useAgreementsTable({
    visibleColumns,
    data: agreements,
    onRowSelect,
  });

  return (
    <FiltersProvider config={config}>
      <BaseLayout
        title={t('pages.agreements.title')}
        actions={[
          <MobileFilters key="filters" />,
          <ColumnFilterPopover
            key="colFilter"
            activeCols={visibleColumns}
            setActiveCols={setColumns}
            columns={columns.map((col) => ({ id: col.id as string, label: col.header as string }))}
            defaultColumns={predefinedCols}
          />,
        ]}>
        <Filters />
        <AgreementsTable />
        {meta && <TablePagination meta={meta} items={agreements.length} />}
      </BaseLayout>
    </FiltersProvider>
  );
};
